/* eslint-disable import/prefer-default-export */

export const HTTP_URI = '/v1/client-api';
